import React from "react";
import '../scss/SurveyResults.scss';
import {useIntl} from "react-intl";
import {useSurveyData} from "./SurveyView";
import {useDataContext} from "./SurveyContextProvider";
import {Link} from "react-router-dom";
import {ReactComponent as ExternalLink} from "../svg/external-link.svg";
import {ReactComponent as RightArrow} from "../svg/right-arrow.svg";

export default function SurveyResults() {
    const intl = useIntl()
    const { value: surveyData } = useDataContext('surveyData')
    const { value: originalSurveyData } = useDataContext('originalSurveyData')
    const canDownload = surveyData.status === "FINISHED" || surveyData.status === "IN PROGRESS" || surveyData.status === "ARCHIVED"
    const statsAvailable = surveyData.status === "FINISHED" || surveyData.status === "ARCHIVED"
    const hostname = window.location.hostname === "localhost" ? 'dev.annieadvisor.com' : window.location.hostname

    function downloadResults(fileType) {
        const downloadURL = `https://${hostname}/api/v2/survey-report.php?returntype=${fileType}&survey=${surveyData.id}`
        window.open(downloadURL, '_blank')
    }

    // Use original survey data so that the link isn't affected by unsaved changes
    const campaign = originalSurveyData?.config?.campaign || null
    const campaignOrSurveyParam = campaign ? `?campaign=${campaign}` : `?survey=${originalSurveyData?.id}`
    const statsParam = statsAvailable ? campaignOrSurveyParam : ''
    const statsLink = `https://${hostname}/stats${statsParam}`
    const buttonText = campaign || originalSurveyData?.config?.title

    return <div className={"survey-results"}>
        <h4>
            {intl.formatMessage(
                {
                    id: 'survey.navigation.results',
                    defaultMessage: 'Results',
                })}
        </h4>
        {canDownload ?
            <>
                <button className={"add-new-button"} onClick={() => downloadResults("xlsx")}>
                    {intl.formatMessage(
                        {
                            id: 'survey.results.downloadReport.xlsx',
                            defaultMessage: 'Download Report (.xlsx)',
                        })}
                </button>
                <button className={"add-new-button"} onClick={() => downloadResults("csvfile")}>
                    {intl.formatMessage(
                        {
                            id: 'survey.results.downloadReport',
                            defaultMessage: 'Download Report (.csv)',
                        })}
                </button>
            </> :
            <>
                <p className={"placeholder"}>
                    {intl.formatMessage(
                        {
                            id: 'survey.results.downloadPlaceholder',
                            defaultMessage: 'Survey results can be accessed when survey is finished or in progress.',
                        })}
                </p>
                <button className={"add-new-button"} disabled>
                    {intl.formatMessage(
                        {
                            id: 'survey.results.downloadReport.xlsx',
                            defaultMessage: 'Download Report (.xlsx)',
                        })}
                </button>
                <button className={"add-new-button"} disabled>
                    {intl.formatMessage(
                        {
                            id: 'survey.results.downloadReport',
                            defaultMessage: 'Download Report (.csv)',
                        })}
                </button>
            </>
        }
        <div className={"stats-link"}>
            <div>
                <h3>
                    {statsAvailable ?
                        intl.formatMessage({
                                defaultMessage: 'Check the results of {campaign}{br}in the Stats App',
                                id: 'ctaToStatsApp.campaign',
                            },
                            {
                                campaign: buttonText,
                                br: <br/>
                            }
                        ) :
                        intl.formatMessage({defaultMessage:'Check the results of all campaigns{br}in the Stats App', id:'ctaToStatsApp.all'},
                            {
                                br: <br/>
                            })
                    }
                </h3>
                <p>
                    {intl.formatMessage({defaultMessage:'Open link in a new tab', id:'openInNewTab'})}
                    <ExternalLink />
                </p>
            </div>
            <RightArrow />
            <a href={statsLink} target={"_blank"} rel={"noreferrer"}/>
        </div>
    </div>
}